export class CompanyEmail {
    public id: number | null;
    public company_business_line_id: number;
    public company_id: number;
    public email_type: string | null;
    public email: string | null;

    constructor(data: CompanyEmailData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.company_business_line_id = 0;
            this.company_id = 0;
            this.email_type = null;
            this.email = null;

        } else {
            this.id = data.id;
            this.company_business_line_id = data.company_business_line_id;
            this.company_id = data.company_id;
            this.email_type = data.email_type;
            this.email = data.email;
        }
    }

    serializeData(): CompanyEmailData {
        return {
            id: this.id,
            company_business_line_id: this.company_business_line_id,
            company_id: this.company_id,
            email_type: this.email_type,
            email: this.email,
        }
    }
}

export type CompanyEmailData = {
    id: number | null;
    company_business_line_id: number;
    company_id: number;
    email_type: string | null;
    email: string | null;
}
